import { BudgetPhases } from 'business/constants';
import { translateBlockValue } from 'i18n';
import { getFieldForPhase } from '../shared/phases/helpers';

export const groupInscriptionsByImputations = (
    inscriptionData: Record<string, ResponseDataValueT>[],
    phase: BudgetPhases,
) => {
    const amountField = getFieldForPhase(phase, 'amount');
    const commentField = getFieldForPhase(phase, 'comment');
    const statusField = getFieldForPhase(phase, 'status');
    return Object.values(
        inscriptionData.reduce(
            (acc: Record<string, Record<string, ResponseDataValueT>>, item) => {
                const {
                    [amountField]: amount,
                    [commentField!]: comment,
                    [statusField!]: status,
                    ...rest
                } = item;
                const key = JSON.stringify(rest);
                if (!acc[key]) {
                    acc[key] = {
                        ...item,
                        [amountField]: 0,
                        [commentField!]: '',
                        [statusField!]: '',
                    };
                }
                // @ts-expect-error [TS migration] ResponseDataValueT should be generic<T>
                acc[key][amountField] += amount;
                acc[key][commentField!] += acc[key][commentField!]
                    ? `\n${comment}`
                    : `${comment}`;
                acc[key][statusField!] += acc[key][statusField!]
                    ? `\n${translateBlockValue(String(status))}`
                    : `${translateBlockValue(String(status))}`;
                return acc;
            },
            {},
        ),
    );
};
